var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMedia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.3,
    height: 78.815,
    viewBox: "0 0 101.3 78.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15549",
    "data-name": "Group 15549",
    transform: "translate(-463.285 -414.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "time-management",
    transform: "translate(463.285 414.154)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1595",
    "data-name": "Ellipse 1595",
    cx: 1.206,
    cy: 1.206,
    rx: 1.206,
    ry: 1.206,
    transform: "translate(0 67.961)",
    fill: "#d1defd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13768",
    "data-name": "Path 13768",
    d: "M9.015,146.89H7.206a1.206,1.206,0,0,0,0,2.412H9.015a1.206,1.206,0,0,0,0-2.412Zm89.844,0H97.05a1.206,1.206,0,0,0,0,2.412h1.809a1.206,1.206,0,0,0,0-2.412Z",
    transform: "translate(-2.382 -78.929)",
    fill: "#c7d6f6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1596",
    "data-name": "Ellipse 1596",
    cx: 1.206,
    cy: 1.206,
    rx: 1.206,
    ry: 1.206,
    transform: "translate(98.888 67.961)",
    fill: "#d1defd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13769",
    "data-name": "Path 13769",
    d: "M90.3,136.592H85.292a1.21,1.21,0,0,0,0,2.412H90.3a1.21,1.21,0,0,0,0-2.412Zm-36.179,0H49.113a1.21,1.21,0,0,0,0,2.412h5.009a1.21,1.21,0,0,0,0-2.412Zm27.644,0H57.648a1.206,1.206,0,1,0,0,2.412h9.611v1.206H62.471a1.206,1.206,0,1,0,0,2.412H77.546a1.206,1.206,0,0,0,0-2.412H72.155V139h9.611a1.206,1.206,0,1,0,0-2.412Zm-24.119-4.824h0Zm26.531,0h0Z",
    transform: "translate(-19.057 -63.807)",
    fill: "#c7d6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13770",
    "data-name": "Path 13770",
    d: "M98.715,85.277a1.3,1.3,0,0,1-1.375,1.206H16.879a1.216,1.216,0,1,1,0-2.412H31.23c-.426-.733,2.84,0,4.173,0H78.817c1.332,0,4.6-.733,4.173,0H97.34A1.3,1.3,0,0,1,98.715,85.277ZM82.429,40.4a1.809,1.809,0,1,0-1.809-1.809A1.809,1.809,0,0,0,82.429,40.4Zm0-2.713a.9.9,0,1,1-.9.9A.9.9,0,0,1,82.429,37.685Zm15.08,17.486a1.206,1.206,0,1,0,1.206,1.206A1.206,1.206,0,0,0,97.509,55.171Zm0,1.809a.6.6,0,1,1,.6-.6A.6.6,0,0,1,97.509,56.98ZM17.715,17.786a1.206,1.206,0,1,0,1.206,1.206A1.206,1.206,0,0,0,17.715,17.786Zm0,1.809a.6.6,0,1,1,.6-.6A.6.6,0,0,1,17.715,19.6Zm68.94-3.485a1.206,1.206,0,1,0,1.206,1.206A1.206,1.206,0,0,0,86.655,16.11Zm0,1.809a.6.6,0,1,1,.6-.6A.6.6,0,0,1,86.655,17.919ZM16.269,51.8A1.206,1.206,0,1,0,15.063,53,1.206,1.206,0,0,0,16.269,51.8Zm-1.809,0a.6.6,0,1,1,.6.6.6.6,0,0,1-.6-.6Z",
    transform: "translate(-6.459 -16.11)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13771",
    "data-name": "Path 13771",
    d: "M5.148,44.843l.9-1.179-.566-.321L4.9,44.664H4.884L4.3,43.353l-.576.33.888,1.151v.019l-1.387-.18v.642l1.4-.179v.019l-.9,1.15.538.34.614-1.331h.018l.566,1.321.595-.339-.906-1.132v-.019l1.424.169v-.642l-1.424.189Z",
    transform: "translate(-1.28 -16.201)",
    fill: "#c7d6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13772",
    "data-name": "Path 13772",
    d: "M47.2,26.44l-.516.663.31.2.353-.766h.011l.326.76.342-.2-.522-.652v-.011l.82.1v-.37l-.82.109V26.26l.516-.679L47.7,25.4l-.332.76h-.011l-.336-.755-.332.19.511.663v.011l-.8-.1v.37l.8-.1Z",
    transform: "translate(-18.422 -9.076)",
    fill: "#c7d6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13773",
    "data-name": "Path 13773",
    d: "M159.866,24.645v-.629l-1.4.185v-.019l.879-1.157-.555-.315-.564,1.3h-.019l-.573-1.286-.565.324.87,1.129v.019l-1.36-.176v.629l1.369-.175v.019l-.879,1.129.528.333.6-1.305h.018l.555,1.3.583-.333-.888-1.111v-.019Z",
    transform: "translate(-62.166 -8.01)",
    fill: "#c7d6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13774",
    "data-name": "Path 13774",
    d: "M78.929,5.063l.758-1-.479-.271-.487,1.117h-.016l-.5-1.109-.487.279.751.974v.016L77.3,4.919v.543l1.182-.151v.016l-.759.974.455.288L78.7,5.462h.016l.479,1.118.5-.288-.766-.958V5.318l1.2.144V4.919l-1.2.16Z",
    transform: "translate(-30.69 -0.499)",
    fill: "#c7d6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "empty",
    transform: "translate(476.455 437.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13775",
    "data-name": "Path 13775",
    d: "M52.491,63.94a1.05,1.05,0,0,0,1.485,0l4.409-4.409,4.409,4.409a1.05,1.05,0,0,0,1.485-1.485l-4.409-4.409,4.409-4.409a1.05,1.05,0,0,0-1.485-1.485L58.385,56.56l-4.409-4.409a1.05,1.05,0,1,0-1.485,1.485L56.9,58.046l-4.409,4.409a1.05,1.05,0,0,0,0,1.485Z",
    transform: "translate(-24.795 -35.13)",
    fill: "#9dbafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13776",
    "data-name": "Path 13776",
    d: "M66.714,28.576l-12.6-8.4A1.05,1.05,0,0,0,53.535,20H1.05A1.062,1.062,0,0,0,0,21.05S0,56.74,0,56.74a1.05,1.05,0,0,0,.467.871l12.6,8.4a1.2,1.2,0,0,0,.583.178H66.131a1.05,1.05,0,0,0,1.05-1.05V29.447A1.05,1.05,0,0,0,66.714,28.576ZM54.584,23.013,62.662,28.4H54.584ZM12.6,63.175,4.519,57.79H12.6Zm0-7.484H2.1V23.013l10.5,7ZM4.519,22.1H52.485v6.3H13.966Zm47.966,8.4V55.69H14.7V30.5ZM14.7,64.088v-6.3H53.215l9.447,6.3Zm50.386-.913-10.5-7V30.5h10.5Z",
    transform: "translate(0 -20)",
    fill: "#9dbafc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMedia);
export default __webpack_public_path__ + "static/media/no-media.cd660f5ff3bf65022d13cd12987c698c.svg";
export { ForwardRef as ReactComponent };